import React from "react";
import Select from "react-select";
import { colors } from "../../../css components/Style";

export default function Categorize({
  categorize,
  setCategorize,
  setSortBy,
  setPage,
}) {
  const options = [
    { value: "ACTIVE", label: "Active Campaigns", color: colors.green },
    { value: "REQUESTED", label: "Campaign Requests", color: colors.yellow },
  ];

  const styles = {
    control: (base, state) => ({
      ...base,
      display: "flex",
      width: "fit-content",
      minHeight: "50px",
      height: "50px",
      padding: "0 18px",
      alignItems: "center",
      borderRadius: "15px",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      border: "none",
      backgroundColor: "#fff",
      justifyContent: "space-between",
      transition: "border 0.2s ease-in-out",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
      ...base,
      display: "flex",
      alignItems: "center",
      paddingLeft: "0px",
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#000000",
      mixBlendMode: "normal",
      opacity: 0.4,
    }),
    placeholder: (base) => ({
      ...base,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#000000",
      mixBlendMode: "normal",
      opacity: 0.4,
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? "#f5f5f5" : "white",
      color: "#212121",
      fontWeight: isSelected ? 600 : 400,
      fontSize: "14px",
      padding: "10px 15px",
      cursor: "pointer",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
      overflow: "hidden",
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "rgba(128, 128, 128, 0.7)", // matches SearchIcon color
      paddingRight: "8px",
    }),
    indicatorSeparator: () => null,
  };

  const handleTypeSelect = (e) => {
    setCategorize(e.value);
    setPage((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  return (
    <Select
      styles={styles}
      options={options}
      onChange={handleTypeSelect}
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
      }}
      value={options.filter(function (option) {
        return option.value === categorize;
      })}
    />
  );
}
